import { render, staticRenderFns } from "./screening-radio-button.vue?vue&type=template&id=608be7bf&scoped=true"
import script from "./screening-radio-button.vue?vue&type=script&lang=js"
export * from "./screening-radio-button.vue?vue&type=script&lang=js"
import style0 from "./screening-radio-button.vue?vue&type=style&index=0&id=608be7bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608be7bf",
  null
  
)

export default component.exports